var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgBgGridDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 391,
    viewBox: "0 0 676 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 4.49133 197.53)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 342.315 387.578)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 28.0057 211.105)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 365.829 374.002)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 51.52 224.68)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 389.344 360.428)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 75.0344 238.255)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 412.858 346.852)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 98.5488 251.83)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 436.373 333.277)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 122.063 265.405)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 459.887 319.703)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 145.578 278.979)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 483.401 306.127)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 169.092 292.556)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 506.916 292.551)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 192.597 306.127)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 530.43 278.977)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 216.111 319.703)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 553.944 265.402)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 239.626 333.277)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 577.459 251.827)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.231 346.905L601.064 151.871",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 600.973 238.252)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 286.654 360.428)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 624.487 224.677)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 310.169 374.002)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 648.002 211.102)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 333.683 387.578)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 671.516 197.527)",
    stroke: "#8492C4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.291 250.127V247.105L296.545 248.965L293.291 250.127Z",
    fill: "#B39DDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBgGridDark);
export default __webpack_public_path__ + "static/media/img-bg-grid-dark.43af653a5db20507c65a141b0ee3625e.svg";
export { ForwardRef as ReactComponent };